"use client";

import { useState } from "react";

export default function BuyTicket() {
  const [ticketContent] = useState({
    title: "This is Racket Riot",
    description:
      "Welcome to Racket Riot Club where the night comes alive with the sound of smashes, rallies, and riotous fun! Founded by passionate players, Racket Riot is a growing community of badminton enthusiasts who play not just for competition, but for connection, laughter, and late-night energy. Whether you're a seasoned shuttler or just picking up a racket, you're always welcome on our courts. Join the riot. Play hard. Laugh harder.",
  });

  return (
    <>
      {/* Reduced padding-top and padding-bottom via inline style */}
      <section id="th-about" className="buy-ticket" style={{ padding: "60px 0" }}>
        <div className="container">
          <div className="row align-items-center"> {/* align-items-center prevents weird vertical gaps */}
            <div className="col-xl-6">
              <div
                className="buy-ticket__left wow fadeInLeft"
                data-wow-delay="100ms"
                style={{ marginBottom: "0", paddingBottom: "0" }}
              >
                <div className="section-title__tagline-box">
                  <span className="section-title__tagline">About Us</span>
                </div>
                
                <h3 className="buy-ticket__title" style={{ marginBottom: "20px" }}>
                  {ticketContent.title}
                </h3>
            
                <p
                  className="buy-ticket__text"
                  style={{ textAlign: "justify", marginBottom: "0" }}
                >
                  {ticketContent.description}
                </p>
              </div>
            </div>

            <div className="col-xl-6">
              <div
                className="buy-ticket__right wow fadeInRight"
                data-wow-delay="300ms"
              >
                {/* Fixed the aspect ratio container for the video */}
                <div className="buy-ticket__img" style={{ lineHeight: "0" }}>
                  <iframe
                    title="RRC_video"
                    src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fracketriotclub%2Fvideos%2F764158169794739%2F&show_text=false&width=560&t=0"
                    width="100%"
                    height="350" // Adjusted height to match text content better
                    style={{ border: "none", overflow: "hidden", borderRadius: "12px" }}
                    scrolling="no"
                    frameBorder="0"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}